import {Dependencies, Expression, Assert, ErrorMessage} from 'interactors/contracts/types';

export function createAssert(di: Dependencies = {}): Assert {
  const {ErrorConstructor: Err = Error} = di;
  const defaultMessage = 'Contract condition failed!';

  return function assert(expression: Expression, message: ErrorMessage = defaultMessage): void {
    if (!expression()) throw new Err(message);
  };
}
